module.exports = __webpack_public_path__ + "img/DE05358.b2324fbe.png";